import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IcmsIconsId } from './generated/icms-icons';

/**
 * Similar to swatch but presents checkbox icon instead
 */
@Component({
    standalone: false,
    selector: 'icms-icon',
    template: `<i [ngClass]="className" [dfs]="'d:inline-flex'"></i>`,
    styleUrls: ['./icms-icon.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsIconComponent {
    @Input()
    icon?: IcmsIconsId;

    get className(): string {
        return `icms-icon-${this.icon || 'ICON-NOT-SET'}`;
    }
}
